import { format } from 'date-fns';
import { MaleImage, FemaleImage } from "../utils/image";
import { apiUrl } from "../utils/apis";


const ImgUrl = apiUrl.imgUrl;

export const formatDMY = (dateString: string): string => {
  if (!dateString) return "-";

  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

 export const formatDate = (dateString?: string) => {
  if (!dateString) return "N/A";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Invalid Date";

  return format(date, "MMMM d, yyyy, hh:mm a");
};
export const formatChatDate = (date: string) =>
  new Date(date).toLocaleDateString(undefined, {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
export const getStatusColor = (status: string ): string => {
  const colors: Record<string, string> = {
    pending: "#f59e0b",   // yellow
    completed: "#16a34a", // green
    rejected: "#dc2626",  // red
    cancelled: "#ef4444", // light red
    "in progress": "#3b82f6",
    approved: "#f4e006ff", // blue
  };

  return colors[status.toLowerCase()] || "#6b7280"; // default gray
};

export const getCaseStatusColor = (status: string ): string => {
  const colors: Record<string, string> = {
    ongoing: "#f59e0b",   // yellow
    closed: "#16a34a", // green
    rejected: "#dc2626",  // red
    draft: "#3b82f6",
    approved: "#f4e006ff", // blue
  };

  return colors[status.toLowerCase()] || "#6b7280"; // default gray
};

export const getAvatar = (
  pic?: string,
  gender?: string
): string => {
  if (pic) {
    return `${pic}`;
  }

  if (gender === "M") {
    return MaleImage;
  }

  if (gender === "F") {
    return FemaleImage;
  }

  return MaleImage;
};


 export const statusColorMap:Record<string, string>  = {
  draft: "#3b82f6",
  ongoing: "#f59e0b",
  closed: "#16a34a",
  rejected: "#dc2626",
};

export const consultationStatusColorMap: Record<string, string> = {
  pending: "#f59e0b",       // yellow
  completed: "#16a34a",     // green
  rejected: "#dc2626",      // red
  cancelled: "#ef4444",     // light red
  "in progress": "#3b82f6", // blue
  approved: "#f4e006ff",    // yellow
};

 export const getConsultationStatusColor = (status?: string) => {
  switch (status?.toLowerCase()) {
    case "pending":
      return "#f59e0b"; // yellow

    case "completed":
      return "#16a34a"; // green

    case "rejected":
      return "#dc2626"; // red

    case "cancelled":
      return "#ef4444"; // light red

    case "in progress":
      return "#3b82f6"; // blue

    case "approved":
      return "#f4e006ff"; // yellow

    default:
      return "#9e9e9e"; // gray fallback
  }
};




export const getSingleCaseStatusColor = (status: string): string => {
  switch (status.toLowerCase()) {
    case "ongoing":
      return "#f59e0b"; // yellow

    case "closed":
      return "#16a34a"; // green

    case "rejected":
      return "#dc2626"; // red

    case "draft":
      return "#3b82f6"; // blue

    case "approved":
      return "#f4e006ff"; // yellow (approved)

    default:
      return "#6b7280"; // gray fallback
  }
};
